export const FETCH_WHATS_NEW = 'FETCH_WHATS_NEW';
export const FETCH_WHATS_NEW_SUCCESS = 'FETCH_WHATS_NEW_SUCCESS';
export const FETCH_WHATS_NEW_ERROR = 'FETCH_WHATS_NEW_ERROR';
